import { render, staticRenderFns } from "./SaveCategory.vue?vue&type=template&id=92fefa64&scoped=true&"
import script from "./SaveCategory.vue?vue&type=script&lang=js&"
export * from "./SaveCategory.vue?vue&type=script&lang=js&"
import style0 from "./SaveCategory.vue?vue&type=style&index=0&id=92fefa64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fefa64",
  null
  
)

export default component.exports